export enum ModelType {
  Dalle = 'Dalle3',
  GptImage1 = 'gpt_image_1',
  GptImage1Edit = 'gpt_image_1_edit',
  SDImageGeneration = 'sd3',
  SDInpaint = 'sd_inpaint',
  SDOutpaint = 'sd_outpaint',
  SDRemoveBackground = 'sd_bgrmv',
  SDRemoveObject = 'sd_objectremove',
  SDImg2Img = 'sd_img2img',
  SDUpscale = 'sd_upscale',
  SDImage2Video = 'sd_img2video',
  SDControlnet = 'sd_sketch',
  SDImage23D = 'sd_image23d',
  BRRemoveObject = 'br_objectremove',
  BRInpaint = 'br_inpaint',
  BRPsd = 'br_psd',
  BRTextToImage = 'br_text2image',
  BRMasks = 'br_masks',
  BRRemoveBackground = 'br_bgrmv',
  BRReplaceBackground = 'br_bgreplace',
  Civit = 'civit',
  IdeogramText2Image = 'ig_text2image',
  IdeogramDescribe = 'ig_describe',
  Replicate = 'replicate',
  FalImported = 'fal_imported',
  NimCC = 'nim_cc',
  BRVector = 'br_vector',
  Luma = 'luma_video',
  LumaVideoModify = 'luma_video_modify',
  LumaRay2 = 'luma/ray-2-720p',
  LumaRay2Flash = 'luma/ray-flash-2-720p',
  RunwayVideo = 'rw_video',
  Runway4Video = 'rw_4_video',
  Runway4VideoOriginal = 'rw_4_video_original',
  Runway4_5VideoOriginal = 'rw_4_5_video_original',
  RunwayActTwo = 'rw_act_2',
  RunwayAleph = 'rw_aleph',
  MehsyImage23D = 'meshy_image23d',
  MochiV1 = 'mochiv1',
  Kling = 'kling',
  Kling16 = 'kling_16',
  Minimax = 'minimax',
  AnyLLM = 'any_llm',
  LTXI2V = 'ltx_i2v',
  Hyper3dRodin = 'hyper_3d_rodin',
  FalFluxMultiLora = 'fal_flux_multilora',
  FalFluxMultiLoraInpaint = 'fal_flux_multilora_inpaint',
  FalFluxKontextLora = 'fal_flux_kontext_lora',
  FalFlux2DevLora = 'fal_flux_2_dev_lora',
  Skyreels = 'skyreels',
  GoogleVeo2 = 'google-veo2',
  KolorsVTO = 'kolors-vto',
  TopazEnhance = 'topaz-enhance',
  TopazSharpen = 'topaz-sharpen',
  TopazUpscaleVideo = 'topaz-upscale-video',
  Trellis3D = 'fal-trellis',
  HunyuanVideoToVideo = 'fal-hunyuan-v2v',
  GeminiEdit = 'gemini_edit',
  Gemini3Edit = 'gemini3_edit',
  Relight2 = 'relight2',
  Wan21Vace = 'wan21_vace',
  Wan22 = 'wan22',
  WanVace14bDepth = 'wan_vace_14b_depth',
  WanVace14bPose = 'wan_vace_14b_pose',
  WanVace14bOutpaint = 'wan_vace_14b_outpaint',
  WanVace14bReframe = 'wan_vace_14b_reframe',
  Imagen4 = 'imagen4',
  FreepikMystic = 'fp_mystic',
  FreepikMagnificUpscale = 'fp_magnific_upscale',
  FreepikMagnificUpscalePrecision = 'fp_magnific_upscale_precision',
  FreepikMagnificUpscalePrecisionV2 = 'fp_magnific_upscale_precision_v2',
  FreepikSkinEnhancer = 'fp_skin_enhancer',
  Vectorizer = 'vectorizer',
  GoogleVeo3 = 'google-veo3',
  GoogleVeo3Fast = 'google-veo3-fast',
  GoogleVeo3T2V = 'google-veo3-t2v',
  GoogleVeo3I2V = 'google-veo3-i2v',
  Seedance = 'fal-seedance',
  MinimaxV2 = 'minimaxV2',
  FluxKontext = 'flux-kontext',
  IdeogramV3 = 'ig_v3',
  IdeogramV3Character = 'ig_v3_character',
  IdeogramV3ReplaceBackground = 'ig_v3_replace_background',
  ElevenLabsVoiceChange = 'elevenlabs_voice_change',
  Moonvalley = 'moonvalley',
  HiggsfieldI2V = 'higgsfield_i2v',
  HiggsfieldT2I = 'higgsfield_t2i',
  Reve = 'reve',
  ReveEdit = 'reve_edit',
  Enhancor = 'enhancor_upscale',
  Ltx2Video = 'ltx2_video',
  Sora = 'sora',
}
